import React, { useState, useEffect, useCallback } from 'react'

import queryString from 'query-string'
import { enUS, de, es, fr, pt } from 'date-fns/locale'
import {
  getSessionGeoCountry,
  setSessionGeoCountry,
  setLocalLanguage,
  getLocalLanguage,
  setLocalCountry,
} from 'utils/authLocalStorage'

import { languageCountryMapping } from './languageCountryMapping'
import { allowFitOnLanguage } from 'hooks/usePagePathType'

const langMap = ['en_US', 'de_DE', 'es_ES', 'fr_FR', 'pt_BR']
const lang2Map = {
  en: 'en_US',
  de: 'de_DE',
  es: 'es_ES',
  fr: 'fr_FR',
  pt: 'pt_BR',
}
// const defaultLang = window.isDev ? 'fr_FR' : 'en_US'
const defaultLang = 'en_US'

const getDateFnsLocale = (code) => {
  const localeMap = {
    en: enUS,
    de: de,
    es: es,
    fr: fr,
    pt: pt,
  }
  return localeMap[code] || enUS
}

const validLang = (lang) => {
  return !!langMap?.find((item) => item.toLowerCase() === lang?.toLowerCase())
}

export const getGeoInfo = async () => {
  const { language_code } = queryString.parse(window.location.search)

  //read language from browser setting
  let mappedLang
  mappedLang = (navigator.languages?.[0] ?? navigator.language)?.replace(
    '-',
    '_'
  )
  if (!mappedLang?.split('_')?.[1]) {
    mappedLang = lang2Map[mappedLang?.split('_')?.[0]]
  }
  if (!validLang(mappedLang)) {
    let _c = mappedLang?.split('_')?.[1]
    let _m = languageCountryMapping[_c?.toUpperCase()]?.languages?.[0]
    mappedLang = lang2Map[_m]
  }
  //read language from browser setting
  if (mappedLang) {
    setLocalCountry(mappedLang?.split('_')?.[1]?.toUpperCase() ?? 'US')
  } else {
    setLocalCountry('US')
    const mappedShortLang = languageCountryMapping['US']?.languages?.[0]
    mappedLang = lang2Map[mappedShortLang]
  }
  let lang
  if (validLang(language_code)) {
    lang = language_code
  } else if (mappedLang) {
    lang = mappedLang
  } else {
    lang = defaultLang
  }
  const localCode = lang?.split('_')[0]
  console.log({ lang, localCode })
  setSessionGeoCountry(localCode)
  setLocalLanguage(lang)

  return {
    lang,
    localCode,
  }
}

const useLokalise = () => {
  const [i18nMap, setI18nMap] = useState({})
  const [i18nMapInit, setI18nMapInit] = useState(false)

  const lang = getLocalLanguage()
  const localCode = getSessionGeoCountry()

  useEffect(() => {
    if (lang === 'en_US') return setI18nMapInit(true)
    setI18nMapInit(false)

    fetch(
      `https://s3.us-east-2.amazonaws.com/lockalise.web/locale/${lang}.json`
    )
      .then((response) => response.json())
      .then((responseJson) => {
        setI18nMap(responseJson ?? {})
        setI18nMapInit(true)
      })
      .catch((error) => {
        console.error(error)
        setI18nMapInit(true)
      })
  }, [lang])

  const lokalise = useCallback(
    (baseString, ...args) => {
      let map = i18nMap
      if (!allowFitOnLanguage()) map = undefined
      let output = map?.[baseString] ?? baseString
      const _args = args
      if (_args?.length) {
        const _list = output.split(/({\d})/g)
        output = (
          <>
            {_list.map((item, index) => {
              if (item.match(/{\d}/))
                return (
                  <React.Fragment key={index}>{_args.shift()}</React.Fragment>
                )
              return item
            })}
          </>
        )
      }
      return output
    },
    [i18nMap]
  )

  return {
    lokalise,
    localCode: allowFitOnLanguage() ? localCode : 'en',
    localLang: allowFitOnLanguage() ? lang : 'en_US',
    langLoading: !i18nMapInit,
    dateFnsLocale: getDateFnsLocale(allowFitOnLanguage() ? localCode : 'en'),
  }
}

export default useLokalise
